module.exports = __webpack_public_path__ + "img/login.22fb2972.jpg";